module.exports = __webpack_public_path__ + "static/media/10w7.61668c4f.jpg";